import { Adeudo, Expediente } from '@conacyt/historicopersonasms-client';
import { Component, Prop, Vue } from 'vue-property-decorator';

import HistoryItemComponent from '@/components/expediente-persona/history-item/history-item.vue';

@Component({
  components: {
    'history-item': HistoryItemComponent,
  },
})
export default class AdeudosComponent extends Vue {
  @Prop({ required: false })
  public expediente: Expediente;

  public numeroCvu = this.$store.getters.account?.id ?? '';

  @Prop({ required: false })
  public noTieneAdeudo: boolean;

  get fields(): any {
    return [
      { key: 'activo', label: 'Adeudo activo', sortable: true },
      { key: 'tipo.descripcion', label: 'Tipo', sortable: true },
      { key: 'monto', label: 'Monto adeudo', sortable: true },
      { key: 'accion', label: 'Constancia', class: 'text-center' },
    ];
  }

  /*
   *Se valida que los adeudos tipo JUICIOS no se muestren al investigador
   */
  get adeudos(): Adeudo[] {
    return this.expediente?.adeudos?.filter(exp => {
      if (exp.tipo.clave === 'JUICIOS' && this.numeroCvu === this.expediente.datosGenerales.persona.cvu) {
        return false;
      }

      return true;
    });
  }
}
